import { render } from "./Confirmation.vue?vue&type=template&id=92455352"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__